module.exports = __webpack_public_path__ + "img/symbol_krone.dd4a30e.webp";